export default __webpack_public_path__ + "static/media/MGS_logo.0aabf991.png";